import * as yup from "yup";
import { InferType } from "yup";
import i18n from "@/i18n";

const accountNumber = /^[0-9]{8}$/;
const bankCode = /^[0-9]{6}$/;
const postalCode = /^[A-Z]{1,2}[0-9]{1,2}[A-Z]?\s?[0-9][A-Z]{2}$/i;

export const BacsAccountSchema = yup.object({
  bankAccountNumber: yup
    .string()
    .matches(accountNumber, {
      message: i18n.t("Account number must contain 8 digits", {
        ns: "paymentMethods",
      }),
    })
    .required(),
  bankAccountName: yup
    .string()
    .min(
      1,
      i18n.t("Account Holder Name is required", {
        ns: "paymentMethods",
      })
    )
    .max(
      30,
      i18n.t("Account Holder Name must be less than 30 characters", {
        ns: "paymentMethods",
      })
    )
    .default(""),
  field_bankCode: yup
    .string()
    .matches(
      bankCode,
      i18n.t("Bank code must contain 6 digits", {
        ns: "paymentMethods",
      })
    )
    .default(""),
  field_streetNumber: yup
    .string()
    .min(
      1,
      i18n.t("Street Number be provided", {
        ns: "paymentMethods",
      })
    )
    .required(),
  field_streetName: yup
    .string()
    .min(
      1,
      i18n.t("Street Name must be provided", {
        ns: "paymentMethods",
      })
    )
    .required(),
  field_email: yup
    .string()
    .email(
      i18n.t("Must be a valid email address", {
        ns: "paymentMethods",
      })
    )
    .required(),
  field_postalCode: yup
    .string()
    .matches(postalCode, {
      message: i18n.t("Postal code must be a valid UK postal code", {
        ns: "paymentMethods",
      }),
    })
    .required(),
  field_state: yup.string().default(""),
  field_city: yup
    .string()
    .min(
      1,
      i18n.t("City must be provided", {
        ns: "paymentMethods",
      })
    )
    .required(),
  field_passthrough4: yup.string().default(""),
  field_passthrough5: yup.string().default(""),
  field_passthrough6: yup.string().default(""),
});

export type BacsAccountSchemaType = InferType<typeof BacsAccountSchema>;

export const EditBacsAccountSchema = yup.object({
  accountHolderInfo: yup
    .object({
      addressLine1: yup.string().default(""),
      addressLine2: yup.string().default(""),
      email: yup
        .string()
        .email(
          i18n.t("Must be a valid email address", {
            ns: "paymentMethods",
          })
        )
        .required(),
      zipCode: yup
        .string()
        .matches(postalCode, {
          message: i18n.t("Postal code must be a valid UK postal code", {
            ns: "paymentMethods",
          }),
        })
        .required(),
      state: yup.string().default(""),
      city: yup
        .string()
        .min(
          1,
          i18n.t("City must be provided", {
            ns: "paymentMethods",
          })
        )
        .required(),
      phone: yup.string().default(""),
    })
    .required(),
  defaultPayment: yup.boolean().default(false),
  nickname: yup.string().default(""),
});

export type EditBacsAccountSchemaType = InferType<typeof EditBacsAccountSchema>;
